<template>
  <div class="pt-100">
    <div class="section section-lg">
      <div class="container"></div>
      <div class="row justify-content-center text-center mb-lg">
        <div class="col-lg-8">
          <h2 class="display-3">Nos réalisations</h2>
          <p class="lead text-muted">
            Quelques campagnes publicitaires que nous avons déployées
          </p>
        </div>
      </div>

      <div class="row" id="bigRow">
        <div
          class="col-md-6 col-lg-4 rol"
          data-aos="fade-up"
          data-aos-duration="1000"
          v-for="(item, index) in tabl"
          :key="index"
          style=" margin-top: 40px;"
        >
          <div
            class="img-carouss is-justify-content-end is-align-items-end"
            :style="{ 'background-image': 'url(' + item.image + ')' }"
            style="background-color: darkgray;"
          >
            <div style="width: 100%;">
              <div class="d-flex ml-4 mb-4 ">
                <div
                  class="bout"
                  :style="{ 'background-color': colorGeneraator() }"
                >
                  {{ item.company.toUpperCase() }}
                </div>
              </div>

              <div class="det-zone text-white">
                <div class="titre-carouss text-center">
                  {{ item.title.toUpperCase() }}
                </div>
                <div class="mt-2 descriptions text-center">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class=""
        style="width: 100%; margin-top: 30px; display: flex; align-items: center; justify-content: center;"
      >
        <base-button
          class="btn-1"
          type="primary"
          @click="$router.push('galerie')"
          >Voir la galerie</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import titreTemplate from "@/views/myComponent/titreTemplate";
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
import gims from "../../public/img/theme/moov/panneau_mobile2.jpg";
import moov from "../../public/img/theme/moov/panneau_mobile10.jpg";
import barbecue from "../../public/img/theme/carlos.jpg";
import estudis from "../../public/img/theme/aab3.jpg";
import isocel from "../../public/img/theme/isocel1.jpg";
import flashMob from "../../public/img/theme/flashMob.jpg";
import flashMob2 from "../../public/img/theme/flash2.jpg";
import fewu from "../../public/img/theme/fewu1.jpg";
import lapaire from "../../public/img/theme/lapaire.jpg";
import aab from "../../public/img/theme/aab/gotoschool.jpg";
import wooding from "../../public/img/theme/woodin/panneau_mobile.jpg";
import wooding2 from "../../public/img/theme/woodin/velopub.jpg";
import lba from "../../public/img/theme/lba.jpeg";
import pmob from "../../public/img/theme/baniere4.jpg";
import superu from "../../public/img/theme/superu.jpg";
import superu2 from "../../public/img/theme/superu2.jpg";
import oremi from "../../public/img/theme/oremi.jpg";
import rato from "../../public/img/theme/rato.jpg";
import nsia from "@/../public/img/theme/nsia/velopub.jpg";
import beautifull from "@/../public/img/theme/beautifulldarkness/velo-place-des-marthy.jpg";
import hamond from "@/../public/img/theme/hamond/velo_publicitaire5.jpg";
import amazone from "@/../public/img/theme/alexandre.jpg";
import celtiis from "@/../public/img/theme/celtiis/celtiis.jpg";
import bookconekt from "@/../public/img/theme/bookconekt.jpg";
import distribution from "@/../public/img/theme/lapaireDist.jpg";
import distributionSuperuCal from "../../public/img/theme/superuDist.jpg";
import nikanor from "../../public/img/theme/nikanor.jpg";
import superuEcole from "@/../public/img/theme/ecoleSuperU.jpg";
import toura from "../../public/img/theme/magicMystic1.jpg";
import ccash from "../../public/img/theme/celtiis/c-cach.jpeg";
import journal from "../../public/img/theme/celtiis/journal.jpeg";
import journalg from "../../public/img/theme/celtiis/eat.jpeg";
import sessime from "../../public/img/theme/centrale/sessime.jpg";
import kemi from "../../public/img/theme/centrale/kemi.jpg";
import lnb from "../../public/img/theme/centrale/lnb.jpg";
import smart from "../../public/img/theme/smartland.jpg";
import vodun from "../../public/img/theme/vodun.jpg";
import sunu from "../../public/img/theme/assistauto.jpg";

export default {
  components: {
    BCarousel,
    BCarouselSlide,
    titreTemplate,
    Hooper,
    Slide,
    HooperNavigation,
  },
  data() {
    return {
      tabl: [
        {
          title: "CARAVANE LNB",
          image: lnb,
          company: "LOTTERIE NATIONALE DU BÉNIN",
          description:
            "Caravane publicitaire pour la promotion de nouvelles offres de la Lotterie Nationale du Bénin",
        },
        {
          title: "CONCERT ELLE",
          image: sessime,
          company: "LA CENTRALE COMPANY",
          description:
            "Campagne de communication sur 10 jours, exclusivement à vélo pour annoncer le concert en l'honneur de la femme au Bénin",
        },
        {
          title: "VODUN DAYS 2024",
          image: vodun,
          company: "CELTIIS",
          description:
            "Déploiement spécial pour la promotion des offres Celtiis à Ouidah lors des Voduns day's du 08 au 10 janvier 2024",
        },

        {
          title: "CAMPAGNE ASSIST@UTO",
          image: sunu,
          company: "SUNU ASSURANCES",
          description:
            "Campagne pour la promotion de l'assistance automobile de SUNU Assurances Bénin",
        },
        {
          title: "LE JOURNAL GÉANT",
          image: journal,
          company: "CELTIIS",
          description:
            "Déploiement spécial pour la promotion des routeurs Celtiis",
        },
        {
          title: "CONCERT ELLE",
          image: kemi,
          company: "LA CENTRALE COMPANY",
          description:
            "Campagne de communication sur 10 jours, exclusivement à vélo pour annoncer le concert en l'honneur de la femme au Bénin",
        },

        {
          title: "LES ORDINATEURS SMART LAND",
          image: smart,
          company: "SMART LAND AFRICA",
          description:
            "Déploiement spécial pour la promotion des ordinateurs SMART LAND dans les universités de Cotonou et Calavi.",
        },
        {
          title: "LE JOURNAL GÉANT",
          image: journalg,
          company: "CELTIIS",
          description:
            "Déploiement des journaux géants sur le festival Eat & Drink",
        },
        {
          title: "GRILLE CELTIIS CASH",
          image: ccash,
          company: "CELTIIS",
          description:
            "Déploiement des moving board pour la promotion des tarifs C-CASH à Canal Olympia",
        },
        {
          title: "LE MAGIC MYSTIC PARTY",
          image: toura,
          company: "TOURA",
          description:
            "Événement organisé pour la promotion des valeurs culturelles béninoise, " +
            "avec une fusion de la magie traditionnelle et celle moderne.",
        },
        {
          title: "OFFRES CELTIIS CASH",
          image: celtiis,
          company: "CELTIIS",
          description:
            "Campagne pour la promotion des tarifs Celtiis Cash à Calavi et à Cotonou",
        },
        {
          title: "NOËL SURPRISE",
          image: superuEcole,
          company: "SUPER U",
          description:
            "Distribution des brochures de Noël dans les écoles marternelle et primaire de Cotonou",
        },
        {
          title: "NIKANOR EN CONCERT LIVE",
          image: nikanor,
          company: "ASUKA MUSIQUE",
          description:
            "Déploiement de nuit dans les artères de la ville de Cotonou pour annoncer le concert de l'artiste Nikanor",
        },
        {
          title: "La poupée qui parle 17 langues africaines",
          image: beautifull,
          company: "BeautifullDarkness",
          description:
            "Campagne pour la promotion des poupées qui parlent 17 langues africaines",
        },
        {
          title: "Consommons le livre Béninois",
          image: bookconekt,
          company: "BOOKCONEKT",
          description:
            "Campagne pour la promotion du livre béninois dans les écoles maternelle primaire et secondaire de Calavi et Cotonou",
        },
        {
          title: "NOËL PRODUITS TOP",
          image: distributionSuperuCal,
          company: "SUPER U",
          description:
            "Distribution des brochures SUPER U dans les ménages à CALAVI",
        },
        {
          title: "Test de vue gratuit",
          image: distribution,
          company: "LAPAIRE",
          description:
            "Campagne de distribution des bons de test de vue gratuit à AKPAKPA",
        },
        {
          title: "Le pouvoir de la fibre",
          image: isocel,
          company: "ISOCEL",
          description:
            "Campagne pour la promotion de la fibre optique au Bénin",
        },

        {
          title: "L'AMAZONE",
          image: amazone,
          company: "L'AMAZONE",
          description:
            "Campagne pour la promotion des liqueurs à base de vin de palme made in Benin",
        },
        {
          title: "FÊWU",
          image: fewu,
          company: "FÊWU",
          description: "Campagne pour la promotion des produits Fêwu au Bénin",
        },
        {
          title: "Produits top à Cotonou",
          image: superu,
          company: "SUPER U",
          description:
            "Campagne pour la promotion des produits TOPS de SUPER U au Bénin",
        },
        {
          title: "Test de vue gratuit",
          image: lapaire,
          company: "LAPAIRE",
          description:
            "Campagne pour la promotion des lunettes lapaire au Bénin",
        },
        {
          title: "La fibre dans vos quartiers",
          image: flashMob,
          company: "ISOCEL",
          description:
            "Flash mob pour la promotion de la fibre optique au Bénin",
        },

        {
          title: "PROMO SUPER U",
          image: superu2,
          company: "SUPER U",
          description:
            "Deuxième campagne pour la promotion des produits TOPS de SUPER U au Bénin",
        },

        {
          title: "Bonus internet à gogo",
          image: moov,
          company: "MOOV AFRICA",
          description:
            "Campagne pour la promotion des offres et tarifs internet du réseau Gsm Moov Africa au Bénin",
        },

        {
          title: "FLASH MOB ISOCEL",
          image: flashMob2,
          company: "ISOCEL",
          description:
            "Flash mob pour la promotion de la fibre optique au Bénin",
        },

        {
          title: "Festizik Cotonou Barbecue",
          image: barbecue,
          company: "KAWERU GROUP",
          description:
            "Campagne publicitaire suivie de vente de ticket pour le festizik Cotonou Barbecue",
        },
        {
          title: "Jeu Tombola rentrée",
          image: wooding,
          company: "WOODIN",
          description:
            "Campagne publicitaire pour la promotion du grand jeu tombola rentrée à Cotonou et Calavi",
        },

        {
          title: "Maître Gims à Cotonou",
          image: gims,
          company: "MOOV AFRICA",
          description:
            "Campagne publicitaire réalisé pour anoncer le concert de Maître Gims au Bénin",
        },

        {
          title: "Go to school",
          image: aab,
          company: "Atlantique Assurances Bénin Vie",
          description:
            "Campagne publicitaire pour la promotion du produit d'assurance étude Go to school au Bénin",
        },

        {
          title: "Coach Hamond Chic à Cotonou",
          image: hamond,
          company: "MC International",
          description:
            "Campagne pour la promotion de la master class et du gala Chic Caviar animé par la coach Hamond Chic",
        },

        {
          title: "Rato",
          image: rato,
          company: "Megamonde",
          description: "Campagne pour la promotion des motos Rato au Bénin",
        },

        {
          title: "Les bonnes affaires",
          image: lba,
          company: "Mojo Crack",
          description:
            "Campagne pour la promotion de l'application des petites anonces LES BONNES AFFAIRES à Calavi",
        },

        {
          title: "Nsia Assistance routière",
          image: nsia,
          company: "Nsia Assurances",
          description:
            "Campagne pour la promotion du produit d'assistance routière de la NSIA Assurances Bénin",
        },
        {
          title: "Jeu Tombola rentrée",
          image: wooding2,
          company: "WOODIN",
          description:
            "Campagne publicitaire pour la promotion du grand jeu tombola rentrée à Porto-Novo et à Sèmè",
        },
        {
          title: "OREMI APP",
          image: oremi,
          company: "Atlantique Assurances Bénin IARD",
          description:
            "Campagne publicitaire pour la promotion de l'application de souscription et de declaration de sinistre OREMI de la compagnie Atlantique Assurance Bénin IARD",
        },
        {
          title: "Estudis",
          image: estudis,
          company: "Atlantique Assurances Bénin Vie",
          description:
            "Promotion du produit de soutient scolaire ESTUDIS de Atlantique Assurances Bénin Vie",
        },
        {
          title: "Tour de ville",
          image: pmob,
          company: "TOK",
          description: "Campagne de lancement des vélos publicitaire à Cotonou",
        },
      ],
      hooperSettings: {
        infiniteScroll: false,
        centerMode: false,
        autoPlay: false,
        playSpeed: 10000,
        breakpoints: {
          2400: {
            itemsToShow: 10,
          },
          1800: {
            itemsToShow: 9,
          },
          1500: {
            itemsToShow: 8,
          },
          1100: {
            itemsToShow: 4,
          },
          1024: {
            itemsToShow: 3.5,
          },
          630: {
            itemsToShow: 3,
          },
          504: {
            itemsToShow: 1.5,
          },
          330: {
            itemsToShow: 1.2,
          },
          0: {
            itemsToShow: 1.1,
          },
        },
      },
    };
  },
  methods: {
    galerie() {
      this.$router.push("/galerie");
    },

    colorGeneraator() {
      let randomColor = Math.floor(Math.random() * 0xffffff).toString(16);
      return "#" + randomColor;
    },
  },
};
</script>
<style scoped>
.porteur {
  padding: 15px;
  width: 100%;
  background: #166276eb;
  border-radius: 5px;
  border: 2px solid white;
}

.descriptions {
  font-weight: 400;
}
.hoppers {
  height: auto;
  color: black;
  width: 100%;
}
.bout {
  width: auto;
  padding: 5px 10px 5px 10px;
  font-size: 12px;
  color: white;
  border-radius: 20px;
  font-weight: 600;
}
.titre-carouss {
  font-size: 20px;
  font-weight: 700;
}
.slide {
  cursor: pointer;
}
.det-zone {
  background-position: center;
  background-color: #177a77f7;
  opacity: 0.9;
  padding: 20px;
  margin-top: 0px;
  border-radius: 20px;
  display: none;
}
.img-carouss {
  height: 450px !important;
  border-radius: 20px 20px 20px 20px;
  /*object-fit: cover;*/
  background-size: cover !important;
  background: linear-gradient(
    0deg,
    rgba(231, 233, 234, 1) 0%,
    rgba(75, 117, 171, 1) 100%
  );
  background-position: center;
  display: flex;
  align-items: end;
}
.img-carouss:hover {
  .det-zone {
    display: block;
  }
  .bout {
    background-color: black !important;
    font-weight: 600;
  }
}

#bigRow {
  margin-left: 50px;
  margin-right: 50px;
}

@media screen and (max-width: 600px) {
  #bigRow {
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media (min-width: 1024px) {
  .det-zone {
    width: 100%;
  }
}
/* @media (min-width: 768px) {
  #membreImg {
    width: 100%;
    height: 250px;
  }
} */
</style>
